import React from "react";

const Gradio = () => {
  return (
    <div style={{ flexGrow: 1 }}>
      <iframe
        title="onconpc"
        className="gradio"
        src="https://onconpc-onconpc-visualization.hf.space"
        frameborder="0"
        width="850"
        height="450"
      ></iframe>
    </div>
  );
};

export default Gradio;
